/* GYMBASE runtime */
(function(){
  /* reveal on scroll */
  var io=('IntersectionObserver' in window)?new IntersectionObserver(function(es){es.forEach(function(e){if(e.isIntersecting){e.target.classList.add('gb-in');io.unobserve(e.target);}});},{threshold:.12}):null;
  function arm(){document.querySelectorAll('.gb-reveal:not(.gb-in)').forEach(function(el){io?io.observe(el):el.classList.add('gb-in');});}
  document.addEventListener('DOMContentLoaded',arm);arm();

  /* free shipping progress (threshold $75) */
  var THRESHOLD=7500;
  function money(c){return '$'+(c/100).toFixed(2).replace(/\.00$/,'');}
  function renderBar(){
    var drawer=document.querySelector('cart-drawer');if(!drawer)return;
    var footer=drawer.querySelector('.drawer__footer');if(!footer)return;
    fetch('/cart.js').then(function(r){return r.json()}).then(function(cart){
      var bar=drawer.querySelector('.gb-ship-bar');
      if(!bar){bar=document.createElement('div');bar.className='gb-ship-bar';bar.innerHTML='<p></p><div class="gb-track"><div class="gb-fill"></div></div>';footer.prepend(bar);}
      var t=cart.total_price,msg=bar.querySelector('p'),fill=bar.querySelector('.gb-fill');
      if(t<=0){bar.style.display='none';return;}
      bar.style.display='';
      if(t>=THRESHOLD){msg.textContent='Free shipping unlocked';fill.style.width='100%';fill.style.background='#1a9a4a';}
      else{msg.textContent=money(THRESHOLD-t)+' away from free shipping';fill.style.width=Math.min(100,Math.round(t/THRESHOLD*100))+'%';fill.style.background='';}
    }).catch(function(){});
  }
  var mo=new MutationObserver(function(){clearTimeout(window.__gbT);window.__gbT=setTimeout(renderBar,250);});
  function watch(){var d=document.querySelector('cart-drawer');if(d){mo.observe(d,{childList:true,subtree:true});renderBar();}}
  document.addEventListener('DOMContentLoaded',watch);watch();
})();